import ApiService from "../ApiService";

export async function apiGetAllOrderedProduct() {
  return ApiService.fetchData({
    url: "/po-list/all",
    method: "get",
  });
}
